import styled from 'styled-components'

const Wrapper = styled.div`
  border: ${props => `solid 1px ${props.theme.borderColor}`};
  margin-top: 2rem;
`

export default Wrapper
